import "./style.css"

const NotFoundPage = () => {
    return (
        <><p style={{color:"white"}}>404 Page not found.</p></>
    )
}

export default NotFoundPage